/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class FITHGameAssets {
    public static MAIN_GAME_BACKGROUND: string = ""; // #257, using it from ImgLoader
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersWays", "fonts/bitmapfonts/NumbersWays.fnt"),
                    new BitmapFontAsset("NumbersFSMulti", "fonts/bitmapfonts/NumbersFSMulti.fnt"),
                    new BitmapFontAsset("NumbersWaysWon", "fonts/bitmapfonts/NumbersWaysWon.fnt")
                ]
            }
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ],
                animations: {
                    "brokeWood": "broke_wood/broke_wood_",
                    "deadExplode": "D_break/D_break_",
                    "bigWinSmoke": "BigWin/smoke",
                    "waysWonText" : "textImg/waysWon",
                    "wayWonText" : "textImg/wayWon",
                    "bigWinTitle1": "BigWin/BigWin_Title1",
                    "bigWinTitle2": "BigWin/BigWin_Title2",
                    "bigWinTitle3": "BigWin/BigWin_Title3",
                    "bigWinTitle4": "BigWin/BigWin_Title4",
                    "bigWinTitle5": "BigWin/BigWin_Title5",
                    "bigWinTitle5I": "BigWin/BigWin_Title5_i",
                    "bigWinTitle5Want": "BigWin/BigWin_Title5_want",
                    "bigWinTitle5Dot": "BigWin/BigWin_Title5_dot",
                    "bigWinTitle5More": "BigWin/BigWin_Title5_more",
                    "bigWinChar1": "BigWin/char_lv01",
                    "bigWinChar2": "BigWin/char_lv2",
                    "bigWinChar3": "BigWin/char_lv3",
                    "bigWinChar4": "BigWin/char_lv4",
                    "bigWinFireParticle1": "BigWin/fireParticles/fire1",
                    "bigWinFireParticle2": "BigWin/fireParticles/fire2",
                    "bigWinFireParticle3": "BigWin/fireParticles/fire3",
                    "bigWinFireParticle4": "BigWin/fireParticles/fire4",
                    "bigWinAmountBg": "BigWin/amount_bg",
                    "finallyIFoundIt": "BigWin/FinallyIFoundIt"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                    new TextureAsset("mainJpeg16", "sheets/mainJpeg/mainJpeg16.json"),
                    new TextureAsset("mainJpeg17", "sheets/mainJpeg/mainJpeg17.json"),
                    new TextureAsset("mainJpeg18", "sheets/mainJpeg/mainJpeg18.json"),
                    new TextureAsset("mainJpeg19", "sheets/mainJpeg/mainJpeg19.json")
                ],
                animations: {
                    "commonWin": "WinEff_A/WinEff_A_",
                    "symWinAnimL1_1": "WinEff_L1_1/WinEff_L1_",
                    "symWinAnimL2_1": "WinEff_L2_1/WinEff_L2_",
                    "symWinAnimL3_1": "WinEff_L3_1/WinEff_L3_",
                    "symWinAnimL4_1": "WinEff_L4_1/WinEff_L4_",
                    "symWinAnimL5_1": "WinEff_L5_1/WinEff_L5_",
                    "symWinAnimM1_1": "WinEff_M1_1/WinEff_M1_",
                    "symWinAnimM2_1": "WinEff_M2_1/WinEff_M2_",
                    "symWinAnimM3_1": "WinEff_M3_1/WinEff_M3_",
                    "symWinAnimM4_1": "WinEff_M4_1/WinEff_M4_",
                    "symWinAnimM5_1": "WinEff_M5_1/WinEff_M5_",
                    "symWinAnimL1_2": "WinEff_L1_2/WinEff_L1_",
                    "symWinAnimL2_2": "WinEff_L2_2/WinEff_L2_",
                    "symWinAnimL3_2": "WinEff_L3_2/WinEff_L3_",
                    "symWinAnimL4_2": "WinEff_L4_2/WinEff_L4_",
                    "symWinAnimL5_2": "WinEff_L5_2/WinEff_L5_",
                    "symWinAnimM1_2": "WinEff_M1_2/WinEff_M1_",
                    "symWinAnimM2_2": "WinEff_M2_2/WinEff_M2_",
                    "symWinAnimM3_2": "WinEff_M3_2/WinEff_M3_",
                    "symWinAnimM4_2": "WinEff_M4_2/WinEff_M4_",
                    "symWinAnimM5_2": "WinEff_M5_2/WinEff_M5_",
                    "symWinAnimBigL": "WinBig_L/WinBig_L_",
                    "symWinAnimBigM1": "WinBig_M1/WinBig_M1_",
                    "symWinAnimBigM2": "WinBig_M2/WinBig_M2_",
                    "symWinAnimBigM3": "WinBig_M3/WinBig_M3_",
                    "symWinAnimBigM4": "WinBig_M4/WinBig_M4_",
                    "symWinAnimBigM5": "WinBig_M5/WinBig_M5_",
                    "explodeEff": "W_explde_eff/W_explode_eff_",
                    "effCoinMulti": "freespin/eff_coin_multi/eff_coin_multi_0",
                    "wagonGlow": "freespin/wagon_glow",
                    "effGlow1": "freespin/eff_glow_01",
                    "effGlow2": "freespin/eff_glow_02",
                    "bagParticle": "freespin/bag_particle/bag_particale_",
                    "chestParticle": "freespin/bag_particle/bag_particale_",
                    "bagScreen": "freespin/bag_screen",
                    "refresh": "freespin/refresh/refresh_",
                    "vSymLandScreen": "freespin/V_glow/V_glow_",
                    "highlightSlot": "freespin/slot_hl/slot_hl_",
                    "vBg": "freespin/V_bg",
                    "gBg": "freespin/G_bg",
                    "rBg": "freespin/R_bg",
                    "dwBg": "freespin/DW_bg",
                    "bigWinFire": "BigWin/BWFire/BW_Fire_",
                    "bigWinFireSmoke": "BigWin/firesmoke/firesmoke_",
                    "fsThemeOutlineGlow": "freespin/theme_glow/theme_glow_",
                    "boardRed": "freespin/board_red",
                    "dotRed": "freespin/dot_red",
                    "reset": "freespin/eff_reset/eff_reset_",
                    "logoIdle": "logo_eff/logo_eff_",
                }
            },
            {
                name: "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations: {
                    "wagonBottom": "R1/R1_bottom",
                    "rBag": "R1/R1_bag",
                    "gOpen": "G/G_open",
                    "g2Open": "G2/G2_open",
                    "dw2": "DW/DW2"
                }
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ]
            },
            // this sheet is not processed from tinyPng
            {
                name: "noTinyPng",
                assets: [
                    new TextureAsset("noTinyPng0", "sheets/noTinyPng/noTinyPng0.json")
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("W_spine", "spine/W.json"),
                    new SpineAsset("B_spine", "spine/B.json"),
                    new SpineAsset("V_spine", "spine/V.json"),
                    new SpineAsset("Anticipation", "spine/Eff_Anticipation.json"),
                    new SpineAsset("FS_Intro", "spine/FS_Intro.json"),
                    new SpineAsset("FS_Info_1", "spine/FS_Info_1.json"),
                    new SpineAsset("FS_Info_2", "spine/FS_Info_2.json"),
                    new SpineAsset("FS_Info_3", "spine/FS_Info_3.json"),
                    new SpineAsset("FS_Info_4", "spine/FS_Info_4.json"),
                    new SpineAsset("FS_Info_5", "spine/FS_Info_5.json"),
                    new SpineAsset("FS_Info_6", "spine/FS_Info_6.json"),
                    new SpineAsset("FS_Info_7", "spine/FS_Info_7.json"),
                    new SpineAsset("FS_Info_8", "spine/FS_Info_8.json"),
                    new SpineAsset("FS_Outro", "spine/FS_Outro.json"),
                    new SpineAsset("BigWinChar", "spine/BigWinChar.json"),
                    new SpineAsset("WildMining", "spine/WildMinning.json"),
                    new SpineAsset("wagon", "spine/Wagon.json"),
                    new SpineAsset("bling", "spine/bling.json"),
                    new SpineAsset("dwarf", "spine/DW.json"),
                    new SpineAsset("bottomChest", "spine/DC.json"),
                    new SpineAsset("beerTime", "spine/BeerTime.json"),
                    new SpineAsset("bWin", "spine/B_win.json"),
                    new SpineAsset("lamp", "spine/lamp_eff.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(FITHGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
}